import { map } from 'rxjs/operators'

export const getCurrentTime = map(data => Math.floor(data.currentTime))
